const paginationLocale = {
  showing: "Showing",
  of: "of",
  items: "items",
  first: "First",
  previous: "Previous",
  next: "Next",
  last: "Last",
  morePages: "More pages"
};
export {
  paginationLocale
};
//# sourceMappingURL=en_US.js.map
